import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IAppointment } from '../models/appointment';
import { IMember } from '../models/member';
import { AppointmentDatesViewModel } from '../models/date';

@Injectable()
export class AppointmentService {
    constructor(private http: HttpClient) { }

    registerLongtermMember(): Observable<IMember> {
        return this.http
            .post<IMember>('/api/appointments/registry', {});
    }

    unRegisterLongtermMember(): Observable<IMember> {
        return this.http
            .delete<IMember>(`/api/appointments/registry`);
    }

    getRegisteredMember(): Observable<IMember> {
        return this.http
            .get<IMember>(`/api/appointments/registry`);
    }

    getDateAppointments(): Observable<AppointmentDatesViewModel[]> {
        return this.http
            .get<AppointmentDatesViewModel[]>('/api/appointments');
    }

    getAppointment(date: string): Observable<IAppointment> {
        return this.http
            .get<IAppointment>(`/api/appointments/${date}`);
    }

    saveAppointment(appointmentId: number): Observable<IAppointment> {
        return this.http.post<IAppointment>(`/api/appointments`, { id: appointmentId });
    }

    deleteAppointment(appointmentId: number): Observable<IAppointment> {
        return this.http.delete<IAppointment>(`/api/appointments?id=${appointmentId}`);
    }
}
